import { Paging } from '@zdrbm/zdr-interfaces';
import { IConversation } from '../model/Conversation';
import { IPageLoaderManager, PageLoaderManager } from './PageLoaderManager';
import { IPlacerAssistantService } from './PlacerAssistantService';

export interface IConversationLoaderManager extends IPageLoaderManager<IConversation> {}

export class ConversationLoaderManager
    extends PageLoaderManager<IConversation>
    implements IConversationLoaderManager
{
    getEntityName(): string {
        return 'ConversationLoaderManager';
    }

    constructor(private service: IPlacerAssistantService) {
        super(50);
    }

    async fetchItems(paging: Paging): Promise<IConversation[]> {
        const conversations = await this.service.listConversations(paging);
        return conversations;
    }
}
